import { Modal } from '../Modal/Modal';
import { ModalHeader } from '../Modal/ModalHeader';

interface FaqPopupProps {
    open: boolean;
    onClose: () => void;
}

export const FaqPopup: React.FC<FaqPopupProps> = ({ open, onClose }) => {
    return (
        <Modal visible={open} onClose={onClose}>
            <div className="sm:-mt-5 -mt-1">
                <ModalHeader onClose={onClose}>WELCOME TO DMEX</ModalHeader>
            </div>
            <div className="flex flex-col text-xxs text-gray-550">
                {/* Flex container for logos */}
                {/*<div className="flex justify-center items-center my-4">
            <img src={MetamaskImage} className="w-20 h-20 mx-2" alt="MetamaskLogo" />
        </div>*/}
                <span className="text-xs text-yellow-550">What is DMEX?</span>
                DMEX is a decentralized derivatives exchange that allows you to trade crypto assets
                with leverage.
                <span className="text-xs text-yellow-550 mt-3">Our Philosophy</span>
                We adhere to old-school cypherpunk philosophy: We do not store user information, do
                not use trackers, and do not respond to requests from authorities.
                <span className="text-xs text-yellow-550 mt-3">No KYC</span>
                DMEX is anonymous and does not require KYC in order to be used.
                {/*  <span className="text-xs text-yellow-550 mt-3">Self Custody</span>
        Your funds are stored on a smart contract and cannot be accessed by the exchange owners. Only you can accesse 
        your funds.*/}
                {/* <span className="text-xs text-yellow-550 mt-3">NO Margin Liquidation</span>
                Unlike other derivatives exchanges, DMEX does not collect your margin when your
                position reaches the liquidation price. Instead, the position is closed at the
                market price and the remaining margin is returned to your balance. */}
                {/* <span className="text-xs text-yellow-550 mt-3">Isolated/Cross Margin Positions</span>
        DMEX is the only decentralized exchange that offers both isolated and cross margin positions. Choose your preferred option.
*/}
                <span className="text-xs text-yellow-550 mt-3">Instant Trade execution</span>
                All trades are confirmed in less than 1 second.
                <span className="text-xs text-yellow-550 mt-3">Instant Withdrawals</span>
                All withdrawals are executed automatically in less than 2 seconds, without any human
                intervention.
                <span className="text-xs text-yellow-550 mt-3">Wallets</span>
                You can either connect your MetaMask (or another Web3 wallet) or generate/import a
                wallet private key. When you first enter DMEX, a wallet is auto-generated for you
                and can be used for trading; just make sure to back up the private key.
                <span className="text-xs text-yellow-550 mt-3">DEMO TRADING</span>
                Upon first entering DMEX, you will receive 1000 DEMO USD to trade and test out the
                platform.
            </div>
        </Modal>
    );
};
